import { render, staticRenderFns } from "./CreditNoteFormTab.vue?vue&type=template&id=6b276048&scoped=true"
import script from "./CreditNoteFormTab.vue?vue&type=script&lang=js"
export * from "./CreditNoteFormTab.vue?vue&type=script&lang=js"
import style0 from "./CreditNoteFormTab.vue?vue&type=style&index=0&id=6b276048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b276048",
  null
  
)

export default component.exports